export const SET_CURRENT_VITALS = 'SET_CURRENT_VITALS'
export const SET_LOADING = 'SET_LOADING'
